import $ from 'jquery';
import { initSidebar } from './layout/sidebar';



function init() {


    console.log('init Wildenberg CP');

        initSidebar();
    
}


init();


